import React, { useEffect, useMemo, useState } from "react";
import "./CustomerLogs.css";

const ITEMS_PER_PAGE = 40;

const CustomerLogs = () => {
  const [loginLogs, setLoginLogs] = useState([]);
  const [registerLogs, setRegisterLogs] = useState([]);
  const [view, setView] = useState("login");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchLogs = () => {
      fetch("/dashboard", {
        credentials: "include",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          setLoginLogs(data.loginLogs || []);
          setRegisterLogs(data.registerLogs || []);
        })
        .catch((error) => console.error("Error fetching data:", error));
    };

    fetchLogs();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [view]);

  const formatTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("th-TH", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const currentLogs = useMemo(() => {
    return view === "login" ? loginLogs : registerLogs;
  }, [view, loginLogs, registerLogs]);

  const totalPages = Math.ceil(currentLogs.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedLogs = currentLogs.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE,
  );

  return (
    <> 
      <div className="dashboard-container">
        <h2  className="cus-info-title">Customer Logs</h2>

        <div className="dashboard-controls">
          <button
            className={`toggle-button ${view === "login" ? "active" : ""}`}
            onClick={() => setView("login")}
          >
            Show Login Logs
          </button>
          <button
            className={`toggle-button ${view === "register" ? "active" : ""}`}
            onClick={() => setView("register")}
          >
            Show Registration Logs
          </button>
        </div>

        <div className="dashboard-card-horizontal">
          {view === "login" && (
            <div className="logs-section-horizontal">
              <table className="logs-table">
                <thead className="logs-table-header">
                  <tr>
                    <th className="logs-table-head">Email</th>
                    <th className="logs-table-head">Time</th>
                    <th className="logs-table-head">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(paginatedLogs) && paginatedLogs.length > 0 ? (
                    paginatedLogs.map((log) => (
                      <tr key={log.id} className="logs-table-row">
                        <td className="logs-table-cell">{log.email}</td>
                        <td className="logs-table-cell">
                          {formatTime(log.login_time)}
                        </td>
                        <td className="logs-table-cell">
                          <span
                            className={
                              Number(log.status) === 1
                                ? "log-status-badge log-status-success"
                                : "log-status-badge log-status-failed"
                            }
                          >
                            {Number(log.status) === 1 ? "Success" : "Failed"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="logs-table-cell" colSpan="3">
                        ไม่พบข้อมูล
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {view === "register" && (
            <div className="logs-section-horizontal">
              <table className="logs-table">
                <thead className="logs-table-header">
                  <tr>
                    <th className="logs-table-head">Email</th>
                    <th className="logs-table-head">Time</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedLogs.length > 0 ? (
                    paginatedLogs.map((log) => (
                      <tr key={log.id} className="logs-table-row">
                        <td className="logs-table-cell">{log.Email}</td>
                        <td className="logs-table-cell">
                          {formatTime(log.Time)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="logs-table-cell" colSpan="2">
                        ไม่พบข้อมูล
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {totalPages > 1 && (
          <div className="ticket-pagination">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;
              return (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={currentPage === page ? "active-page" : ""}
                >
                  {page}
                </button>
              );
            })}

            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CustomerLogs;
